module.exports = {
  getCookie(cookieName) {
    const cookies = document.cookie;
    const cookieList = cookies ? cookies.split('; ') : [];
    for (const cookieItem of cookieList) {
      const [, _cookieName, _cookieValue] = cookieItem.match(/^(.*?)=(.*)/);
      if (_cookieName === cookieName) {
        return _cookieValue;
      }
    }
    return void 0;
  },
  setCookie(key, value) {
    document.cookie = `${key}=${value}`
  },
  removeCookie(key) {
    // 通过设置过期时间来实现删除， path也是必须，因为需要知道作用范围，没有设置则会生成一个空的同名属性。
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
  },
}